import script from "./TTextareaElement.vue?vue&type=script&lang=js"
export * from "./TTextareaElement.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__